// src/pages/ResetPasswordPage/ResetPasswordPage.js

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function ResetPasswordPage({ enterpriseId }) {
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Убираем общий errorMsg для паролей; 
  // Оставим только для ошибки «Ссылка недействительна» или других глобальных ошибок.
  const [globalError, setGlobalError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  // Проверка токена из query-параметров
  const location = useLocation();
  const [tokenIsValid, setTokenIsValid] = useState(false);

  // Простая валидация пароля (латиница/цифры, 4-50 символов)
  const isPasswordValid = (val) => /^[A-Za-z0-9]{4,50}$/.test(val);

  // Проверяем «token» при загрузке
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    // Если token === "valid", считаем что ссылка валидна
    if (token && token === "valid") {
      setTokenIsValid(true);
    } else {
      setTokenIsValid(false);
    }
  }, [location.search]);

  // ---------------- Inline-валидация (как в LoginPage/InviteRegistrationPage) ----------------
  // Получить ошибку для «Новый пароль»
  const getNewPasswordError = () => {
    // Пока поле пустое — не показываем ошибку (но кнопка будет заблокирована).
    if (newPassword.length === 0) return "";
    if (!isPasswordValid(newPassword)) {
      return "Пароль должен быть от 4 до 50 символов, только латиница и цифры.";
    }
    return "";
  };

  // Получить ошибку для «Подтверждение пароля»
  const getConfirmPasswordError = () => {
    if (confirmPassword.length === 0) return "";
    if (confirmPassword !== newPassword) {
      return "Пароли не совпадают.";
    }
    return "";
  };

  // Форма валидна, если:
  // - tokenIsValid = true
  // - поля не пусты
  // - нет ошибок в getNewPasswordError() / getConfirmPasswordError()
  const isFormValid = () => {
    if (!tokenIsValid) return false;
    // Проверяем, что поля не пусты
    if (!newPassword.trim() || !confirmPassword.trim()) return false;
    // Проверяем, что нет ошибок
    if (getNewPasswordError() || getConfirmPasswordError()) return false;
    return true;
  };

  // ---------------- Сабмит ----------------
  const handleSubmit = (e) => {
    e.preventDefault();
    setGlobalError("");
    setSuccessMsg("");

    // Если форма почему-то невалидна (кнопка обычно будет disabled)
    if (!isFormValid()) {
      setGlobalError("Пожалуйста, заполните поля корректно.");
      return;
    }

    // Если всё ОК
    setSuccessMsg("Пароль успешно изменён! Теперь вы можете войти в систему.");
  };

  // ---------------- Inline-ошибки ----------------
  const newPasswordError = getNewPasswordError();
  const confirmPasswordError = getConfirmPasswordError();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f0f0",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#fff",
          padding: "2rem",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          width: "350px",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
          Сброс пароля
        </h2>

        {/* Если сам token недействителен */}
        {!tokenIsValid && (
          <div
            style={{
              color: "red",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            Ссылка недействительна или устарела.
          </div>
        )}

        {/* Глобальная ошибка (если есть) */}
        {globalError && (
          <div
            style={{
              color: "red",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {globalError}
          </div>
        )}

        {/* Сообщение об успехе */}
        {successMsg && (
          <div
            style={{
              color: "green",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
            }}
          >
            {successMsg}
          </div>
        )}

        {/* Поле «Новый пароль» */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label htmlFor="newPassword">Новый пароль</label>
          <div style={{ position: "relative" }}>
            <input
              type={showNewPassword ? "text" : "password"}
              id="newPassword"
              placeholder="Введите новый пароль"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{ 
                width: "100%", 
                padding: "0.5rem", 
                paddingRight: "40px" 
              }}
              disabled={!tokenIsValid}
            />
            {/* Кнопка «Показать/Скрыть» */}
            <button
              type="button"
              onClick={() => setShowNewPassword(!showNewPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showNewPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {/* Inline-ошибка для нового пароля */}
          {newPasswordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {newPasswordError}
            </p>
          )}
        </div>

        {/* Подсказка к формату пароля (необязательно) */}
        {/* <p
          style={{
            fontSize: "0.8rem",
            marginTop: "-0.5rem",
            marginBottom: "1rem",
            color: "#555",
          }}
        >
          Требования: 4-50 символов, латиница и цифры.
        </p> */}

        {/* Поле «Подтверждение пароля» */}
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label htmlFor="confirmPassword">Подтверждение пароля</label>
          <div style={{ position: "relative" }}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              placeholder="Повторите пароль"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{ 
                width: "100%", 
                padding: "0.5rem", 
                paddingRight: "40px" 
              }}
              disabled={!tokenIsValid}
            />
            {/* Кнопка «Показать/Скрыть» */}
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{
                position: "absolute",
                top: "50%",
                right: "8px",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              {showConfirmPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
          {/* Inline-ошибка для подтверждения пароля */}
          {confirmPasswordError && (
            <p style={{ color: "red", fontSize: "0.9rem", marginTop: "0.3rem" }}>
              {confirmPasswordError}
            </p>
          )}
        </div>

        {/* Кнопка «Сохранить» */}
        <button
          type="submit"
          disabled={!isFormValid()} 
          style={{
            width: "100%",
            padding: "0.5rem",
            backgroundColor: isFormValid() ? "#007bff" : "#cccccc",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: isFormValid() ? "pointer" : "not-allowed",
          }}
        >
          Сохранить
        </button>
      </form>
    </div>
  );
}

export default ResetPasswordPage;
